import { render, staticRenderFns } from "./AdminNotificationDropDown.vue?vue&type=template&id=50824d32&"
import script from "./AdminNotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./AdminNotificationDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports